/**
 * 平台: fusion端webview
 * 通用能力:
 * 1.bridge esappBridge
 * 2.登录: fusionLogin | fusionIsLogin
 * 3.定位: fusionLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { utils } from '@didi/webx-js-core';
import FusionClass from '@didi/fusion';
import { sdkReady } from '../../loader';
import { storage } from '../../../storage';
import { EsAppJump } from './goTo';
function commonJump(loadParams, xenv, commonParams = {}) {
    new EsAppJump(loadParams, xenv, commonParams).doJump();
}
function initCallMethod(bridge) {
    bridge.call = function (FnName, params, callback) {
        if (typeof FnName !== 'string') {
            console.error('bridge.call FnName必须使用string类型， 传入FnName: ', FnName);
            return;
        }
        if (FnName in bridge) {
            bridge[FnName](params, callback);
        }
        else {
            console.error(`bridge.call 不存在"${FnName}"方法`);
        }
    };
}
let esappBridge = new FusionClass(['CommonModule', 'TraceModule']);
if (esappBridge)
    initCallMethod(esappBridge);
const esappLocate = () => {
    return new Promise((resolve, reject) => {
        esappBridge.getLocationInfo({}, (res) => {
            if (res && (res.lat || res.lng || res.cityId || res.city_id)) {
                /* 获取定位信息成功 存入缓存 */
                storage.locationInfo = {
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || '')
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: res.cityId || res.city_id });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || '')
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const esappIsLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        esappBridge.getUserInfo({}, res => {
            try {
                if (utils.isStr(res)) {
                    res = JSON.parse(res);
                }
            }
            catch (error) {
                res = {};
            }
            const { useQuick } = option || {};
            if (res && res.phone) {
                const userInfo = {
                    token: res.token || res.ticket,
                    phone: res.phone,
                    uid: res.uid
                };
                /* 获取用户信息成功 存入缓存 */
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                /* 获取用户信息失败 存入缓存 */
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const esappLogin = () => {
    return new Promise((resolve, reject) => {
        esappIsLogin().then(resolve, () => {
            esappBridge.requestLogin({}, res => {
                if (res && (res.userInfo.token || res.userInfo.ticket) && res.userInfo.phone) {
                    /* 获取用户信息成功 存入缓存 */
                    storage.userInfo = {
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    });
                }
                else {
                    /* 获取用户信息失败 存入缓存 */
                    storage.userInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject({
                        extraInfo: {
                            login_result: res.login_result
                        }
                    });
                }
            });
        });
    });
};
const esappPay = (options) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { pay, config, useOld, version, lang, mini_url, successUrl, mini_back, ...args } = options;
    if (!pay.appid) {
        pay.appid = 'wxe9875a55496b6b34';
    }
    if (!config) {
        config = args;
    }
    return new Promise((resolve, reject) => {
        sdkReady('DpayWeb', 'https://img-ys011.didistatic.com/static/ddpay_fe/DpayWeb-1.1.2.js', DpayWeb => {
            DpayWeb.pay(pay, config);
            DpayWeb.registerPaySuc((res) => {
                resolve(res);
            });
            DpayWeb.registerPayFail((err) => {
                reject(err);
            });
            DpayWeb.registerClose((err) => {
                reject({
                    err,
                    code: 2
                });
            });
        });
    });
};
const esappGetSystemInfo = () => {
    return new Promise((resolve) => {
        esappBridge.getSystemInfo({}, (res) => {
            const result = {
                ...res,
                ddfp: res.ddfp || res.imei
            };
            delete result.imei;
            resolve(result);
        });
    });
};
export { esappBridge, esappLogin, esappIsLogin, esappLocate, esappPay, esappGetSystemInfo, commonJump as esappCommonJump };
